import React from "react";
import { BundleMallCount, BundlePrice, BundlePriceUnit, BundleRadio, BundleRadioLabel, BundleRankingLabel, BundleStatusText, HiddenBundleRadio, WrapperBundleItem, WrapperName, WrapperPriceInfo } from "./bundle_item.style";
import { numberFormat } from "../../../../utils/util";
import { priceValue } from "../../../../utils/priceValue";
export default function BundleItem(_a) {
    var _b, _c;
    var bundle_item = _a.bundle_item, isMinishop = _a.isMinishop, currentItemID = _a.currentItemID;
    var isRadioChecked = currentItemID === bundle_item.item_id;
    var itemLink = "".concat(process.env.REACT_APP_SHOPPING_URL, "/detail/").concat(bundle_item.item_id).concat(isMinishop ? "/".concat(isMinishop.idx_b_manager) : '');
    /**
     * 서브 도메인에 minishop 이 없음
     * api에서 minishop > idx_b_manager가 있는 경우 minishop으로 간주하여 처리
     * 없는 경우에는 undefined 값
     */
    var domain = (isMinishop === null || isMinishop === void 0 ? void 0 : isMinishop.idx_b_manager) ? 'minishop' : '';
    var isBundlePriceShow = (_b = priceValue(bundle_item.f_sellout, bundle_item.price, bundle_item.cnt_stock, bundle_item.seller, domain)) === null || _b === void 0 ? void 0 : _b.isShow;
    var bundleStatusText = (_c = priceValue(bundle_item.f_sellout, bundle_item.price, bundle_item.cnt_stock, bundle_item.seller, domain)) === null || _c === void 0 ? void 0 : _c.statusText;
    var onClickRadioButton = function () {
        if (isRadioChecked) {
            return;
        }
        else {
            window.open(itemLink, '_blank');
        }
    };
    return (React.createElement(WrapperBundleItem, null,
        React.createElement(WrapperName, null,
            React.createElement(BundleRadioLabel, { title: bundle_item.bundle_nm, isRadioChecked: isRadioChecked },
                bundle_item.bundle_nm,
                React.createElement(HiddenBundleRadio, { type: "radio", name: String(currentItemID), checked: isRadioChecked, readOnly: true, onClick: onClickRadioButton }),
                React.createElement(BundleRadio, null)),
            (!!bundle_item.bundle_rank && bundle_item.bundle_rank < 3) &&
                React.createElement(BundleRankingLabel, null,
                    bundle_item.bundle_rank,
                    "\uC704")),
        React.createElement(WrapperPriceInfo, null,
            React.createElement(BundlePrice, { isRadioChecked: isRadioChecked }, isBundlePriceShow
                ? React.createElement(React.Fragment, null,
                    " ",
                    numberFormat(bundle_item.price),
                    React.createElement(BundlePriceUnit, null, "\uC6D0"))
                : React.createElement(BundleStatusText, { isRadioChecked: isRadioChecked }, bundleStatusText)),
            React.createElement(BundleMallCount, { isRadioChecked: isRadioChecked },
                bundle_item.market_real_count,
                "\uBAB0"))));
}



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/tab/bundle_group/bundle_item/bundle_item.container.tsx
// module id = 270
// module chunks = 0